import styled from "styled-components"

export const QueryBuilderWrapper = styled.div`
  min-width: fit-content;
  width: 100%;
  li {
    list-style-type: none;
  }
`
